import React from 'react';
import { chapters } from '../data/chapters';

interface SidebarProps {
  activeId: string;
  onSelect: (id: string) => void;
}

export default function Sidebar({ activeId, onSelect }: SidebarProps) {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">{"// os-journal"}</div>
        <div className="sidebar-title">Building an OS from Scratch</div>
        <div className="sidebar-subtitle">3 attempts. 1 working shell.</div>
      </div>

      <nav className="sidebar-nav">
        {chapters.map((ch) => (
          <div
            key={ch.id}
            className={`nav-item ${activeId === ch.id ? 'active' : ''}`}
            onClick={() => onSelect(ch.id)}
          >
            <span className="nav-number">
              {ch.number === 0 ? '~' : String(ch.number).padStart(2, '0')}
            </span>
            <div className="nav-text">
              <div className="nav-chapter-title">{ch.title}</div>
              <div className="nav-chapter-sub">{ch.subtitle}</div>
            </div>
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div>arch: riscv32 + x86</div>
        <div style={{ marginTop: 4 }}>built with qemu + clang</div>
      </div>
    </aside>
  );
}
